import { render, staticRenderFns } from "./EnergyPriceSetForm.vue?vue&type=template&id=236a5e5c&scoped=true&"
import script from "./EnergyPriceSetForm.vue?vue&type=script&lang=js&"
export * from "./EnergyPriceSetForm.vue?vue&type=script&lang=js&"
import style0 from "./EnergyPriceSetForm.vue?vue&type=style&index=0&id=236a5e5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236a5e5c",
  null
  
)

export default component.exports